import { Component, OnInit, Inject } from '@angular/core';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { GlobalService } from '../../services/global.service';
import { LogOcorrencia } from 'src/app/models/log-ocorrencia';
import { Funcionario } from 'src/app/models/funcionario';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { OcorrenciaService } from 'src/app/services/ocorrencia.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-log-ocorrencia',
  templateUrl: './log-ocorrencia-modal.component.html',
  styleUrls: ['./log-ocorrencia-modal.component.scss']
})
export class LogOcorrenciaComponent implements OnInit {
  idOcorrencia: number;
  logsOcorrencia: LogOcorrencia[] = [];
  integrador: Funcionario = new Funcionario();
  campoOrdenacao = 'dataHora';
  ordenarDesc = false;
  usuarioLogado: UsuarioLogado;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<LogOcorrenciaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ocorrenciaService: OcorrenciaService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private utilitarioService: UtilitarioService,
    private globalService: GlobalService
  ) {
    this.idOcorrencia = data.idOcorrencia;
  }

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.buscarLogsOcorrencia();
  }

  buscarLogsOcorrencia() {
    this.carregandoService.mostra("buscaOcorrencia");
    this.ocorrenciaService.consultarLogsOcorrencia(this.idOcorrencia).subscribe(data => {
      this.logsOcorrencia = data;
      this.carregandoService.esconde("buscaOcorrencia");
    }, (erro) => {
      this.carregandoService.esconde("buscaOcorrencia");
      this.notificacaoService.erro("Não foi possível buscar os logs");
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  fechar() {
    this.dialogRef.close();
  }
}
